// Keep each measured question with its heading and preserve its stable identity.
export function paginatePreviewItems(items, heights, capacity) {
  if (!items.length) return [];
  const pages = [];
  let page = [], used = 0;
  items.forEach((item, index) => {
    const height = Math.max(1, Math.ceil(heights[index] || 1));
    if (page.length && used + height > capacity) {
      pages.push(page); page = []; used = 0;
    }
    page.push(item); used += height;
  });
  if (page.length) pages.push(page);
  return pages;
}
